import { IRoleName } from 'features/cost-analysis/team/role-names';
import { BaseService } from 'shared/services/BaseService';

class RoleNameService extends BaseService<IRoleName> {
  constructor() {
    super('staff-management/role-names');
  }
  canDelete = true;
}

export const roleNameService = new RoleNameService();
